<template>
  <div class="max-w-4xl h-auto flex items-center justify-center h-auto flex-wrap mx-auto my-28 lg:my-0 pt-5">
    <a class="no-underline hover:no-underline" href="https://www.greengeeks.com/">
      <img alt="GreenGeeks logo" src="/static/img/amui/logo_black.png" class="mb-6">
    </a>
    <div class="bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow-md w-full lg:w-4/5" role="alert">
      <div class="flex">
        <div class="py-1">
          <svg class="fill-current h-6 w-6 text-teal-500 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/>
          </svg>
        </div>
        <div>
          <p class="font-bold mb-0">GreenGeeks Seal</p>
          <p class="text-sm mb-0">
            Login to your account and visit the Profile section to learn about GreenGeeks Seal.
          </p>
          <br/>
          <p style="text-align:center;">
            <button @click="startSession('login')"
                  class="bg-transparent hover:bg-green-600 text-green-600 hover:text-white px-2 mt-2 border border-green-600 hover:border-transparent rounded">
              Login
            </button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'LoginSeal',
  methods: {
    ...mapActions(['initializeSession']),
    startSession (name) {
      this.initializeSession()
      this.$router.push({ name })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/seal";
</style>
